<template>
  <div class="pinwall__post">
    <div v-if="!item.approved && !item.owner" class="not-approved">
      <label class="label">{{ $t("post.notApproved") }}</label>
      <button
        v-if="item.editable"
        @click="$emit('delete', item)"
        class="button is-text"
        slot="trigger"
      >
        <b-icon icon="delete"></b-icon>
      </button>
    </div>
    <div v-else>
      <div v-if="item.embed && item.embed.type === 'instagram'">
        <InstagramEmbed
          :className="'instagram-content'"
          :html="item.embed.html"
        />
      </div>
      <div v-else-if="item.embed && item.embed.type === 'twitter'">
        <TwitterEmbed :className="'twitter-content'" :html="item.embed.html" />
      </div>
      <div v-else-if="item.html" class="html-content">
        <iframe
          :src="item.html.source"
          allowfullscreen="allowfullscreen"
          webkitallowfullscreen
          mozallowfullscreen
          frameborder="0"
        ></iframe>
      </div>
      <div v-else class="media-content">
        <Audio
          @ended="ended"
          v-if="item.audio"
          :post="item"
          :muted="view === 'list' ? true : false"
          :view="view"
        ></Audio>
        <Video
          @ended="ended"
          v-else-if="item.video"
          :post="item"
          :muted="view === 'list' ? true : false"
          :view="view"
          playsinline
        />
        <img
          v-else-if="item.image || replaceByDefaultCounter > 1"
          :src="item.image.source"
          @click="$emit('fullscreen', item)"
          @error="
            post.image.type === 'local' ? replaceByDefault($event, post) : ''
          "
        />
        <div v-if="bubbleTopFound" class="speech-bubble-top">
          {{ bubbleTopFound }}
        </div>
        <div v-if="bubbleBottomFound" class="speech-bubble-bottom">
          {{ bubbleBottomFound }}
        </div>
      </div>
      <div class="file-container" v-if="item.file">
        <b-button
          @click="download(item)"
          type="is-light"
          icon-left="download"
          rounded
        >
          <p>{{ item.file.fileName.replace(`${item.id}-`, "") }}</p>
        </b-button>
        <b-button
          v-if="item.hasFilePreview"
          class="file-preview"
          :title="$t('post.previewFile')"
          type="is-text"
          @click="$emit('filePreview', item)"
          icon-left="file-find"
        ></b-button>
      </div>
      <div v-if="!mode || (mode != 'screen' && mode != 'fullscreen')">
        <Play v-if="item.quiz" :post="item"></Play>
        <Fill v-if="item.poll" :post="item"></Fill>
        <div
          :class="
            item.style && item.style !== '' && !item.style.includes(';color')
              ? 'text color'
              : 'text'
          "
          v-html="!bubbleTopFound && !bubbleBottomFound ? item.text : ''"
          v-linkified
        ></div>
        <div class="meta-info-image">
          <UserImage
            :username="item.username"
            :src="item.userImg"
            :view="'post'"
          />
          <span
            v-if="item.createDate"
            class="create-date"
            :title="new Date(item.createDate).toLocaleString('de-DE')"
          >
            {{
              new Date(item.createDate).toLocaleString("de-DE").split(",")[0]
            }}
          </span>
        </div>
        <div v-if="item.approved">
          <div class="post-action">
            <b-button
              :class="mode !== 'search' ? 'like-button' : 'like-search-button'"
              @click="like(item.id)"
              type="is-text"
            >
              <b-icon
                class="like-icon"
                icon="thumb-up-outline"
                size="is-small"
              ></b-icon>
              <span>{{ post.likes || 0 }}</span>
            </b-button>
            <b-button
              v-if="withComments"
              class="comment-button"
              @click="$emit('openComments', item)"
              type="is-text"
            >
              <b-icon
                class="comment-icon"
                icon="comment-outline"
                size="is-small"
              ></b-icon>
              <span>{{ item.comments ? item.comments.length : 0 }}</span>
            </b-button>
            <b-dropdown
              v-if="mode !== 'search'"
              class="menu-dropdown"
              position="is-top-left"
              aria-role="list"
            >
              <button class="button is-text" slot="trigger">
                <b-icon icon="dots-horizontal"></b-icon>
              </button>
              <b-dropdown-item
                v-if="item.editable"
                @click="$emit('editPost', item)"
                aria-role="listitem"
              >
                <b-icon icon="pencil" size="is-small"></b-icon>{{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="isDownloadActive"
                @click="download(item)"
                aria-role="listitem"
              >
                <b-icon icon="download" size="is-small"></b-icon
                >{{ $t("download") }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="item.editable && item.image"
                @click="setPosterImage(item)"
                aria-role="listitem"
              >
                <b-icon icon="image" size="is-small"></b-icon>{{ $t("set") }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="item.video && item.video.type === 'local'"
                @click="copyUrl(item)"
                aria-role="listitem"
              >
                <b-icon icon="content-copy" size="is-small"></b-icon
                >{{ $t("copyUrl") }}
              </b-dropdown-item>
              <!-- <b-dropdown-item @click="like(item.id)" aria-role="listitem">
              <b-icon icon="thumb-up" size="is-small"></b-icon>
              {{ post.likes || 0 }}
            </b-dropdown-item> -->
              <b-dropdown-item
                v-if="post.editable"
                @click="$emit('delete', item)"
                aria-role="listitem"
              >
                <b-icon icon="delete" size="is-small"></b-icon
                >{{ $t("delete") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div v-else class="approve-buttons">
          <button
            @click="$emit('delete', item)"
            class="button is-text delete-button"
            slot="trigger"
          >
            <b-icon icon="delete"></b-icon>
          </button>
          <button
            @click="$emit('approvePost', item)"
            class="button is-text check-button"
            slot="trigger"
          >
            <b-icon icon="checkbox-marked-outline"></b-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import Video from "./Video";
import Audio from "./Audio";
import { copyStringToClipboard, downloadURI } from "../../utils/helpers";
import InstagramEmbed from "../core/InstagramEmbed.vue";
import TwitterEmbed from "../core/TwitterEmbed.vue";
import UserImage from "../core/UserImage.vue";
import Play from "../quiz/Play.vue";
import Fill from "../poll/Fill.vue";

export default {
  name: "post",
  props: {
    post: {
      type: Object
    },
    withComments: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: null
    },
    view: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      isModalActive: false,
      isDownloadActive: false,
      item: null,
      bubbleTopFound: null,
      bubbleBottomFound: null,
      replaceByDefaultCounter: 0
    };
  },
  watch: {
    post: "init",
    "post.w": "setImageSrc",
    windowWidth: "setImageSrc"
  },
  components: {
    Video,
    Audio,
    InstagramEmbed,
    TwitterEmbed,
    UserImage,
    Play,
    Fill
  },
  mounted() {
    this.setImageSrc();
  },
  methods: {
    ...mapActions(["likePost", "saveImage"]),
    ...mapMutations(["setStoredLike"]),
    ended() {
      this.$emit("ended");
    },
    like(id) {
      this.likePost(id).then(likeId => {
        this.setStoredLike(likeId);
      });
    },
    copyUrl(item) {
      copyStringToClipboard(
        `https:${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_VIDEO_CDN_URL
        }${item.video.fileName.split(".")[0]}/master.m3u8`
      );
    },
    setPosterImage(item) {
      if (item.video) {
        item.image.type = "local-video";
      }
      this.saveImage(item.image);
    },
    setImageSrc() {
      this.$nextTick(() => {
        this.width = this.$el.clientWidth;
        if (
          this.item.image &&
          this.item.image.type &&
          this.item.image.type === "local" &&
          !this.item.video
        ) {
          if (this.mode === "fullscreen" && this.item.image.original) {
            this.item.image.source = this.item.image.source.replace(
              this.item.image.source.split("/").pop(),
              this.item.image.original
            );
          } else if (this.width > 720) {
            let fileExtensions =
              this.item.image.mimeType &&
              this.item.image.mimeType.includes("png")
                ? ".png"
                : ".jpg";
            this.item.image.source = this.item.image.source.replace(
              ".webp",
              fileExtensions
            );
          } else if (!this.item.image.source.includes(".webp")) {
            this.item.image.source = this.item.image.source
              .replace(".jpg", ".webp")
              .replace(".png", ".webp");
          }
        }
      });
    },
    removeUserImg() {
      this.item.userImg = "data:image/gif;base64,R0lGODlhAQABAAAAACw=";
    },
    replaceByDefault(e) {
      let fileExtensions =
        this.item.image.mimeType && this.item.image.mimeType.includes("png")
          ? ".png"
          : ".jpg";

      if (this.replaceByDefaultCounter === 0) {
        e.target.src = this.item.image.source.replace(".webp", fileExtensions);
      } else if (this.replaceByDefaultCounter === 1) {
        e.target.src =
          fileExtensions === ".png"
            ? this.item.image.source.replace(".webp", ".jpg")
            : this.item.image.source.replace(".webp", ".png");
      }

      this.replaceByDefaultCounter = this.replaceByDefaultCounter + 1;
    },
    download(item) {
      if (item.video && item.video.type === "local") {
        downloadURI(item.video.downloadUrl, item.video.fileName);
        return;
      }
      if (item.audio && item.audio.type === "local") {
        downloadURI(item.audio.downloadUrl, item.audio.fileName);
        return;
      }
      if (item.file && item.file.type === "local") {
        downloadURI(item.image.downloadUrl, item.image.fileName);
        return;
      }
      if (item.image && item.image.type === "local") {
        downloadURI(item.image.downloadUrl, item.image.fileName);
        return;
      }
      if (item.file) {
        downloadURI(item.file.downloadUrl, item.file.fileName);
        return;
      }
    },
    init() {
      this.item = this.post;

      if (
        this.item.image &&
        this.item.image.type &&
        this.item.image.type === "local" &&
        !this.item.video
      ) {
        if (this.mode === "fullscreen" && this.item.image.original) {
          this.item.image.source = this.item.image.source.replace(
            this.item.image.source.split("/").pop(),
            this.item.image.original
          );
        } else if (
          (this.view === "list" && this.windowWidth > 720) ||
          (this.view === "grid" && Math.ceil(this.windowWidth / 4) > 720)
        ) {
          let fileExtensions =
            this.item.image.mimeType && this.item.image.mimeType.includes("png")
              ? ".png"
              : ".jpg";
          this.item.image.source = this.item.image.source.replace(
            ".webp",
            fileExtensions
          );
        } else if (!this.item.image.source.includes(".webp")) {
          this.item.image.source = this.item.image.source
            .replace(".jpg", ".webp")
            .replace(".png", ".webp");
        }
      }

      this.setImageSrc();

      if (
        (this.item.video && this.item.video.type === "local") ||
        (this.item.audio && this.item.audio.type === "local") ||
        (this.item.file && this.item.file.type === "local") ||
        (this.item.image && this.item.image.type === "local") ||
        this.item.file
      ) {
        this.isDownloadActive = true;
      }

      if (this.item.file) {
        if (
          !/([^\s]+(\.(doc|docx|xls|xlx|ppt|pptx))$)/i.test(
            this.item.file.fileName
          )
        ) {
          this.item.hasFilePreview = true;
        }
      }

      if (this.item.links) {
        this.item.links.map(link => {
          switch (link.type) {
            case "video":
              this.item.video = this.item.video || {
                source: link.url,
                type: "local"
              };
              break;
            case "image":
              this.item.image = this.item.image || {
                source: link.url,
                type: "image"
              };
              break;
            case "file":
              this.item.file = this.item.file || {
                source: link.url,
                type: "file"
              };
              break;
            case "html":
              this.item.html = {
                source: link.url,
                type: "html"
              };
              break;
          }
        });
      }

      // Check if showing speach bubble
      if (this.item.text) {
        const bubbleTopRegex = /&lt;bt&gt;(.*?)&lt;bt&gt;/gm;
        const bubbleBottomRegex = /&lt;bb&gt;(.*?)&lt;bb&gt;/gm;

        this.bubbleTopFound = this.item.text.match(bubbleTopRegex)
          ? this.item.text.match(bubbleTopRegex)[0].replaceAll("&lt;bt&gt;", "")
          : null;
        this.bubbleBottomFound = this.item.text.match(bubbleBottomRegex)
          ? this.item.text
              .match(bubbleBottomRegex)[0]
              .replaceAll("&lt;bb&gt;", "")
          : null;
      }
    }
  },
  created() {
    this.init();
  }
};
</script>
